module.exports = __webpack_public_path__ + "static/media/slide-5.0aac2fa6.webp";